import { gql } from "graphql-tag";

export const GET_SPRINTS = gql`
  query GetSprints($projectId: ID!, $onlyActive: Boolean = true) {
    sprints(projectId: $projectId, onlyActive: $onlyActive) {
      id
      number
      label
      projectId
      startDate
      endDate
      color
      active
    }
  }
`;

export const GET_SPRINTS_FOR_PROJECTS = gql`
  query GetSprintsForProjects(
    $projectIds: [ID!]!
    $onlyActive: Boolean = true
  ) {
    sprintsForProjects(projectIds: $projectIds, onlyActive: $onlyActive) {
      id
      number
      label
      projectId
      startDate
      endDate
      color
      active
    }
  }
`;

export const GET_ALL_SPRINTS = gql`
  query GetAllSprints {
    allSprints {
      id
      number
      label
      projectId
      startDate
      endDate
      color
      active
    }
  }
`;
